module.exports = __webpack_public_path__ + "static/media/DaysWorked5.5893afb4.png";